import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.SplitViewWrapper.PreviewToggleButton', {
    showPreview: 'File preview',
    hidePreview: 'No preview',
});
